export default {
  userMgment: {
    userOper: {
      title: '用户列表',
      userId: '用户id',
      accountNo: '账号',
      citizenship: '国籍',
      firstName: '名',
      fullName: '全名',
      lastName: '姓',
      gender: '性别',
      mailBox: '邮箱',
      middleName: '中间名',
      mobileNumber: '手机号',
      nickName: '昵称',
      phoneAreaCode: '电话区号',
      groupId: '集团id',
      orgId: '组织id',
      password: '密码',
      confirmPassword: '确认密码',
      userType: '用户类型'
    },
    roleOper: {
      title: '角色列表',
      roleId: '角色ID',
      roleName: '角色名称',
      roleNameEn: '角色英文名',
      roleNameZh: '角色中文名',
      roleDesc: '角色描述',
      adminFlag: '是否管理员',
      defaultFlag: '是否默认角色',
      enableFlag: '是否有效'
    },
    menuOper: {
      title: '菜单列表',
      btnTitle: '添加顶级节点',
      dataflagItem0: '是',
      dataflagItem1: '否',
      isOpenItem0: '是',
      isOpenItem1: '否',
      isMenu: '是否是菜单',
      isOpen: '是否打开',
      levels: '菜单层级',
      menuCode: '菜单简码',
      menuDesc: '菜单描述',
      menuIcon: '菜单图标',
      id: '菜单ID',
      menuNameEn: '菜单英文名',
      menuNameZh: '菜单中文名',
      menuPcode: '菜单父简码',
      menuPcodes: '菜单全路径简码',
      menuUrl: '菜单URL',
      moduleId: '系统名称',
      orderNum: '菜单排序'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/authority/lang/zh.js